import { t } from '@lingui/macro';
import { LanguageCodeType } from 'noddi-web';

export function getQuantityOptionsWithTrans(quantityMax: number) {
  return Array.from({ length: quantityMax }, (_, i) => ({
    label: `${i + 1} ${t`pcs`}`,
    value: i + 1
  }));
}

export const getServiceCategoryTranslations = ({ serviceCategoryName }: { serviceCategoryName: string }) => {
  if (serviceCategoryName === 'Wheel change') {
    return {
      name: t`Wheel change`
    };
  } else if (serviceCategoryName === 'Car wash') {
    return {
      name: t`Car wash`
    };
  } else if (serviceCategoryName === 'Wheel storage') {
    return {
      name: t`Wheel storage`
    };
  }

  return null;
};

export function getErrorCodes() {
  return {
    invalid_phone_number: t`invalid_phone_number`,
    invalid_verification_code: t`invalid_verification_code`,
    invalid_code: t`invalid_code`,
    user_not_naf_member: t`user_not_naf_member`,
    new_user_not_eligible_for_campaign: t`new_user_not_eligible_for_campaign`,
    booking_time_window_not_bookable: t`booking_time_window_not_bookable`,
    user_phone_or_email_already_exists: t`user_phone_or_email_already_exists`,
    capacity_contribution_already_exists: t`capacity_contribution_already_exists`,
    car_not_found: t`car_not_found`,
    credentials_invalid: t`credentials_invalid`,
    phone_number_verification_error: t`phone_number_verification_error`,
    pin_code_verification_error: t`pin_code_verification_error`,
    password_verification_failed: t`password_verification_failed`,
    genericErrorMessage: t`genericErrorMessage`,
    car_statens_vegvesen_not_found: t`Could not find car in Statens Vegvesen register`,
    authentication_failed: t`Your session has expired. Try refreshing the page, or sign in again in a new browser tab`,
    not_authenticated: t`Your session has expired. Try refreshing the page, or sign in again in a new browser tab`,
    vehicle_type_not_supported: t`This vehicle type is not supported`,
    car_not_found_car_info: t`We couldn't find the car you searched for in the national vehicle registry`,
    invalid_pin_code: t`The code you entered does not match the one we sent you`,
    throttled: t`You've tried too many times, so we've temporarily blocked your request. If you need help, please contact us at hei@noddi.no`,
    tire_quote_already_has_selected_item: t`You have already accepted this tire offer`
  } as const;
}

type LocaleData = {
  label: string;
  flag: string;
};

type SupportedLocalesType = {
  [key in LanguageCodeType]: LocaleData;
};

export const getSupportedLocales = (): SupportedLocalesType => ({
  en: { label: t`English`, flag: '🇬🇧' },
  nb: { label: t`Norwegian`, flag: '🇳🇴' },
  se: { label: t`Swedish`, flag: '🇸🇪' }
});
